import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ILoggedInDetails } from '@Interface/Login';

interface AppState {
    loggedInDetails: ILoggedInDetails,
    selectedMenu: string,
    datalayers: any
}

const initialState: AppState = {
    loggedInDetails: {},
    selectedMenu: 'home',
    datalayers: {}
};


const AppSlice = createSlice({
    name: 'applicationSlice',
    initialState,
    reducers: {
        storeLoggedInDetails: (state, action: PayloadAction<ILoggedInDetails>) => {
            state.loggedInDetails = { ...state.loggedInDetails, ...action.payload }
        },
        storeSelectedMenu: (state, action: PayloadAction<string>) => {
            state.selectedMenu = action.payload
        },
        storeDatalayers: (state, action: PayloadAction<any>) => {
            state.datalayers = action.payload
        },
        resetStoredState: (state) => {
            console.info('resetStoredState', state);
        }
    }
})

export const AppServices = {
    actions: AppSlice.actions,
};

const AppReducer = AppSlice.reducer;
export default AppReducer;